import React from 'react';
import { Query } from 'react-apollo';
import { API } from 'aws-amplify';
import MaterialTable from 'material-table';
import { Link } from 'react-router-dom';
import Spin from 'components/common/Spin';
import { GET_USERS, UPDATE_USER } from 'graphql/admin/users';
import Helmet from 'react-helmet';
import { resetPassword } from 'utils/admin.service';
import useSnack from 'hooks/useSnack';
import { useSelector } from 'react-redux';
import { useMutation } from '@apollo/react-hooks';
import { Button } from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const Guardians = (props) => {
  const snack = useSnack();
  const user = useSelector((s) => s.user.user);
  const [updateUser] = useMutation(UPDATE_USER);
  const [showPrompt, togglePrompt] = React.useState(false);
  const [username, setUsername] = React.useState();
  const [confirmationText, setconfirmationText] = React.useState();

  const handlePromptOpen = (event,user) => {
    event.stopPropagation()
    togglePrompt(true);
    setUsername(user.user_email);
  };

  const deleteUser = async () => {
    if (confirmationText === username) {
      try {
        await API.post('api', `/admin/user/delete/${username}`);
        snack.success('User successfully deleted');
        togglePrompt(false);
      } catch (e) {
        snack.error(e.message);
      }
    } else {
      snack.error('Emails do not match');
    }
  };

  const handlePromptClose = () => {
    togglePrompt(false);
  };

  const columns = [
    { title: 'User Id', field: 'user_id', type: 'numeric', editable: 'never' },
    { title: 'Status', field: 'user_status', editable: 'never' },
    { title: 'Username', field: 'user_cognito_username', editable: 'never' },
    { title: 'Preferred Name', field: 'user_preferred_name', editable: 'never' },
    { title: 'First Name', field: 'user_first_name' },
    { title: 'Last Name', field: 'user_last_name' },
    {
      title: 'Student Name',
      render: (row) => {
        const child = row.children[0];
        if (!child) return null;
        return row.children.map((child) => {
          return <Link to={`/students/${child.student_id}/profile`}>
          {`${child.student.user_first_name} ${child.student.user_last_name}, `}
        </Link>
        })
      },
    },
    { title: 'User Email', field: 'user_email' },
    { title: 'Phone', field: 'user_phone' },
  ];

  const onResetPassword = async (e, data) => {
    if (window.confirm('Are you sure?')) {
      return resetPassword(data.user_cognito_username)
        .then(() => snack.success('Password updated.'))
        .catch((e) => snack.error(e.message));
    }
  };

  return (
    <Query
      query={GET_USERS}
      variables={{ user_type: 'parent', includeChildren: true }}
      fetchPolicy={'cache-and-network'}
    >
      {({ data, refetch }) => {
        if (!data) return <Spin spinning linear />;

        const onCreateAccount = (e, data) => {
          const username = window.prompt('Enter username for this user:');
          if (username) {
            return API.post('api', '/admin/users', {
              body: {
                username,
                email: data.user_email,
                usertype: 'parent',
                firstName: data.user_first_name,
                lastName: data.user_last_name,
              },
            }).then(
              () => {
                snack.success('User created');
                refetch();
              },
              ({ response }) => {
                snack.error(response.data.message);
              },
            );
          }
        };

        return (
          <React.Fragment>
            <Helmet title="Guardians" />
            <MaterialTable
              title="Guardians"
              columns={columns}
              data={data.users}
              actions={[
                {
                  icon: 'visibility',
                  tooltip: 'View',
                  onClick: (event, rowData) =>
                    props.history.push(
                      `/students/${rowData.children[0].student_id}/profile/parents`,
                    ),
                },
                {
                  icon: () => <DeleteForeverIcon disabled={user.id != process.env.REACT_APP_ADMIN_ID} />,
                  tooltip: 'Delete permanently',
                  onClick: (event, rowData) => handlePromptOpen(event, rowData),
                  disabled:  user.id != process.env.REACT_APP_ADMIN_ID
                },
                (rowData) => {
                  if (rowData.user_cognito_username) {
                    return {
                      icon: 'lock',
                      tooltip: 'Reset password',
                      onClick: onResetPassword,
                    };
                  }
                  return {
                    icon: 'edit',
                    tooltip: 'Create account',
                    onClick: onCreateAccount,
                  };
                },
              ]}
            />
            {showPrompt && (
              <Dialog
                open={prompt}
                onClose={handlePromptClose}
                aria-labelledby="form-dialog-title"
              >
                <DialogTitle id="form-dialog-title">Are you sure ?</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    This will delete the user permanently.
                  </DialogContentText>
                  <TextField
                    value={confirmationText}
                    onChange={(e) => setconfirmationText(e.target.value)}
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Type email address of user to confirm"
                    type="email"
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button onClick={handlePromptClose}>Cancel</Button>
                  <Button
                    variant="contained"
                    onClick={deleteUser}
                    color="secondary"
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
            )}
          </React.Fragment>
        );
      }}
    </Query>
  );
};

export default Guardians;
